var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-image-inline-item",class:_vm.format},[_c('img',{class:_vm.align,attrs:{"src":_vm.url}}),(_vm.legend && _vm.desc)?_c('div',{staticClass:"legend p-2"},[_vm._v(" "+_vm._s(_vm.legend)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }